export { default } from './DotLoader';
export * from './DotLoader';
